import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="auth-layout auth-layout--glass">
      <div className="auth-layout__backdrop" aria-hidden />
      <div className="auth-layout__content">
        <Outlet />
      </div>
    </div>
  );
}
